export default "__VITE_ASSET__749bba7c__"